<div
  class="value-pillar-container flex flex-col grow gap-4 py-6 pl-9 pr-10 transition-colors duration-300 ease-in-out box-border justify-between h-full"
    [ngClass]="[
    valuePillarBorder,
    (makingSelectionsState || isExpanded) ? 'bg-white text-blue' : 'bg-white/15 text-white'
    ]"
>
    <div class="value-pillar-header flex gap-5">
        <!-- Vertical line with color-->
        <div class="value-pillar-color w-2 rounded-full" [ngClass]="valuePillarColor"></div>
        <div class="value-pillar-title text-4xl" [ngClass] = "(makingSelectionsState || isExpanded) ? 'text-neptune-neutral' : 'text-white'">{{valuePillar}}</div>
    </div>
 
    <div class="value-pillar-body flex flex-col gap-6">
        <div class="value-pillar-metrics flex flex-col grow pl-7">
            <ng-container *ngIf="!isLoading; else loader">
                <span class="value-pillar-total text-5xl">{{currencyCode | currencySymbol}}{{displayInRoundedNumber ? (valuePillarTotal | abbreviateNumber) : valuePillarTotal}}</span>
                <ng-container *ngIf="showDefaultTotal">
                    <span class="value-pillar-default-total text-2xl" [ngClass] = "isExpanded ? 'text-shuttle-gray' : 'text-neptune-neutral'">Default {{currencyCode | currencySymbol}}{{displayInRoundedNumber ? (valuePillarDefaultTotal | abbreviateNumber) : valuePillarDefaultTotal}}</span>
                </ng-container>
            </ng-container>
            <ng-template #loader>
                <loader size="medium"></loader>
            </ng-template>
        </div>

        <!-- If add to presentation experience is in progress the value pillars are already expanded-->
        <ng-container *ngIf="!makingSelectionsState">
            <ng-container *ngIf="!noMetricsForValuePillar; else noMetricsAvailable">
                <div 
                    class="value-pillar-expand-button neptune-action-button" 
                    [ngClass] ="isExpanded ? 'border-blue' : 'border-white'"
                    (click)="!isLoading && toggleRequested.emit()"
                    *ngIf="!isLoading"
                >
                    <ng-container *ngIf="!isLoading">
                        <span class="text-sm">View Details</span>
                        <ng-container *ngIf="!isExpanded; else closeIcon">
                            <img src="assets/shared-icons/neptune-icon-white-chevron-down.svg" alt="Expand" class="w-5 h-5">
                        </ng-container>
                        <ng-template #closeIcon>
                            <img src="assets/shared-icons/neptune-icon-blue-close.svg" alt="Collapse" class="w-5 h-5">
                        </ng-template>
                    </ng-container>
                </div>
                <ng-container *ngIf="isLoading">
                        <loader size="small"></loader>
                    </ng-container>
            </ng-container>

            <ng-template #noMetricsAvailable>
                <!-- All program and Pest can add custom tiles if no metrics are available -->
                <!-- Distributor cannot add custom tiles -->
                <ng-container *ngIf="division != Division.Distributor && (selectedProgram==availablePrograms.ALL || division==Division.Pest) && !isLoading; else noMetricsMessage">
                    <div class="value-pillar-add-custom-tile-button neptune-action-button border-white" (click)="createCustomTileRequested.emit()">
                        <span class="text-sm">Add Custom Tile</span>
                        <img src="assets/shared-icons/neptune-icon-white-chevron-down.svg" alt="Collapse" class="w-5 h-5 -rotate-90">
                    </div>
                </ng-container>

                <ng-template #noMetricsMessage>
                    <div class="value-pillar-no-metrics text-white text-xl" *ngIf="!isLoading">There are currently no automated TVD metrics in place.</div>
                </ng-template>

                <ng-container *ngIf="isLoading">
                    <loader size="small"></loader>
                </ng-container>
            </ng-template>
        </ng-container>
        
        
    </div>
</div>